// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"_2ffFt _38618 _1X7sA _3Dqep","modalTextArea":"_10mBH _2kZNz _17S31 _2hwsw _2z9kb"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/RevisionMessageModal.css
// module id = 2648
// module chunks = 3